import React from 'react';
import {Modal, Form, Input, InputNumber, Button} from 'antd';
import {b64DecodeUnicode} from '../utils'
const FormItem = Form.Item;
const {TextArea} = Input;

const StationModalForm = Form.create()((props) => {
  const {
    title,
    station,
    stations,
    visible,
    onCancel,
    onSubmit,
    form
  } = props;
  const info = JSON.parse(b64DecodeUnicode(station.MoreInfo))
  const {getFieldDecorator} = form;
  return (<Modal visible={visible} title={title} okText="Lưu" cancelText="Bỏ qua" onCancel={onCancel} onOk={onSubmit} footer={[
      <Button key="cancel" onClick={onCancel}>Bỏ qua</Button>,
      <Button key="submit" type="primary" ghost="ghost" onClick={onSubmit}>
        Lưu
      </Button>
    ]}>
    <Form layout="vertical">
      {getFieldDecorator('ID', {initialValue: station.ID})(<span/>)}
      <FormItem label="Tên trạm">
        {
          getFieldDecorator('Name', {
            rules: [
              {
                required: true,
                message: 'Phải nhập tên trạm!'
              }, {
                validator: (rule, value, cb) => {
                  if (value) {
                    if (value !== station.Name) {
                      const index = stations.findIndex((item) => {
                        return item.Name === value
                      })
                      if (index > -1) {
                        cb("Tên trạm đã sử dụng!")
                      }
                    }
                  }
                  cb()
                }
              }
            ],
            initialValue: station.Name
          })(<Input/>)
        }
      </FormItem>
      <FormItem label="Tài khoản">
        {
          getFieldDecorator('UserName', {
            rules: [
              {
                required: true,
                message: 'Phải nhập tài khoản!'
              }
            ],
            initialValue: station.UserName
          })(<Input/>)
        }
      </FormItem>
      <FormItem label="Mật khẩu">
        {
          getFieldDecorator('Password', {
            rules: [
              {
                required: true,
                message: 'Phải nhập mật khẩu!'
              }
            ],
            initialValue: station.Password
          })(<Input type="password" placeholder='••••••••••' autoComplete="new-password"/>)
        }
      </FormItem>
      <FormItem label="Địa chỉ">
        {getFieldDecorator('MoreInfo.addr', {initialValue: info.addr})(<Input/>)}
      </FormItem>
      <FormItem label="Mô tả">
        {getFieldDecorator('MoreInfo.desc', {initialValue: info.desc})(<TextArea/>)}
      </FormItem>
      <FormItem label="Kinh độ">
        {
          getFieldDecorator('MoreInfo.lng', {
            initialValue: info
              ? info.lng
              : 0
          })(<InputNumber min={0} max={180} step="1.000"/>)
        }
      </FormItem>
      <FormItem label="Vĩ độ">
        {
          getFieldDecorator('MoreInfo.lat', {
            initialValue: info
              ? info.lat
              : 0
          })(<InputNumber min={0} max={180} step="1.000"/>)
        }
      </FormItem>
    </Form>
  </Modal>);
})

export default StationModalForm



// WEBPACK FOOTER //
// ./src/components/StationModalForm.js